import { PaymentAPI as t } from "../../../js/payments/paymentApi.js";
const o = [
  ...t.THIRD_PARTY_METHODS,
  t.PaymentMethodType.CASH
];
export {
  o as HIDEN_FRAME_METHODS
};
//# sourceMappingURL=payment.types.js.map
